import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'react-modal';
import ReportVehicles from './ReportVehicles';
import { getReportVehiclesMulti } from '../../actions/apiGetInfo';
import { setReportVehicles } from '../../actions/apiSetInfo';

const ReportVehiclesModal = ({
  report_id: initialReportId,
  department_id: initialDepartmentId,
  reportIds,
  departmentIds,
}) => {
  const dispatch = useDispatch();
  const isAlias = Array.isArray(reportIds) && reportIds.length > 0;
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [report_id, setReportId] = useState(initialReportId);
  const [department_id, setDepartmentId] = useState(initialDepartmentId);

  useEffect(() => {
    setReportId(initialReportId);
    setDepartmentId(initialDepartmentId);
  }, [initialReportId, initialDepartmentId]);

  const openModal = (newReportId, newDepartmentId) => {
    if (isAlias) {
      setDepartmentId(newDepartmentId);
      dispatch(setReportVehicles([]));
      setModalIsOpen(true);
      dispatch(getReportVehiclesMulti(reportIds));
    } else if (newReportId > 0) {
      setReportId(newReportId);
      setDepartmentId(newDepartmentId);
      setModalIsOpen(true);
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
    dispatch(setReportVehicles([]));
  };

  return (
    <div className="col-md-3">
      <div className="btn-group">
        <button
          className="btn btn-large btn-success btn-block"
          onClick={() => openModal(initialReportId, initialDepartmentId)}
        >
          <i className="fal fa-car" />
        </button>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={() => {}}
        onRequestClose={closeModal}
        contentLabel="Report Vehicles"
        className="customModal"
        ariaHideApp={false}
        overlayClassName="report-overlay"
      >
        <div className="customCard">
          <div className="customHeader">
            <button
              type="button"
              className="btn btn-danger btn-sm float-end space-left-2"
              aria-label="Close"
              onClick={closeModal}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <ReportVehicles
            report_id={isAlias ? 0 : report_id}
            department_id={department_id}
            departmentIds={isAlias ? departmentIds : undefined}
          />
        </div>
      </Modal>
    </div>
  );
};

export default ReportVehiclesModal;